import { render, staticRenderFns } from "./plan-details-zoneduschcmp.vue?vue&type=template&id=51488cfa"
import script from "./plan-details-zoneduschcmp.vue?vue&type=script&lang=js"
export * from "./plan-details-zoneduschcmp.vue?vue&type=script&lang=js"
import style0 from "./plan-details-zoneduschcmp.vue?vue&type=style&index=0&id=51488cfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports